<!-- Plantilla compartida: la pintan el detalle de Desarrollo y el de QA (detallesincidencia); lo común está en detalles-comun. -->
<div class="main-content incidencia-detalle-page" [style.--status-color]="statusColor">
  <div class="container-fluid">
    <section class="incidencia-detalle-page__hero">
      <div class="incidencia-detalle-page__hero-main">
        <div class="incidencia-detalle-page__hero-title-row">
          <span class="incidencia-detalle-page__ticket-id">
            #{{ detallemodal.id_incidencia_proyecto }}
          </span>

          <div class="incidencia-detalle-page__hero-copy">
            <h1>{{ detallemodal.titulo }}</h1>
            <p>Proyecto: {{ nombreProyecto || "Sin proyecto asignado" }}</p>
          </div>

          <span class="incidencia-detalle-page__status-chip"
            [style.--status-color]="colorEstatusChip"
            [class]="'incidencia-detalle-page__status-chip status-' + getStatusSlug()">
            {{ detallemodal.estatus }}
          </span>
        </div>
      </div>

      <div class="incidencia-detalle-page__hero-actions">
        <button type="button" mat-raised-button class="btn app-form-btn app-form-btn--secondary"
          (click)="onCloseClick()">
          Regresar
        </button>

        <button type="button" mat-raised-button class="btn app-form-btn" *ngFor="let accion of getHeaderActions()"
          [class.app-form-btn--primary]="getActionTone(stringify(accion.titulo)) !== 'neutral'"
          [class.app-form-btn--secondary]="getActionTone(stringify(accion.titulo)) === 'neutral'"
          [disabled]="accionBloqueada(stringify(accion.titulo)) || accionEnCurso(stringify(accion.titulo))"
          [attr.aria-busy]="accionEnCurso(stringify(accion.titulo)) ? 'true' : null"
          [attr.aria-describedby]="accionBloqueada(stringify(accion.titulo)) ? 'detalle-motivo-revision' : null"
          [attr.title]="accionBloqueada(stringify(accion.titulo)) ? motivoRevisionPendiente : null"
          (click)="agregaComentario(stringify(accion.titulo))">
          <span class="material-icons detalle-resolucion__candado" aria-hidden="true"
            *ngIf="accionBloqueada(stringify(accion.titulo))">lock</span>
          {{ getActionLabel(stringify(accion.titulo)) }}
        </button>

        <!-- T3b: la resolución espera versión y el servidor rechazaría la revisión (VAL-RES-PENDIENTE). -->
        <p class="detalle-resolucion__motivo" *ngIf="revisionBloqueada()">
          <span id="detalle-motivo-revision" class="detalle-resolucion__motivo-texto">
            <span class="material-icons" aria-hidden="true">schedule</span>
            <span><strong>Enviar a revisión:</strong> {{ motivoRevisionPendiente }}</span>
          </span>
        </p>
      </div>
    </section>

    <div class="incidencia-detalle-page__layout">
      <div class="incidencia-detalle-page__main">
        <div class="incidencia-detalle-page__meta-grid">
          <section class="incidencia-detalle-page__card incidencia-detalle-page__card--compact">
            <header class="incidencia-detalle-page__eyebrow-header">
              Información Técnica
            </header>

            <div class="incidencia-detalle-page__kv-list">
              <div class="incidencia-detalle-page__kv-item">
                <span>Prioridad</span>
                <strong class="incidencia-detalle-page__priority-chip"
                  [class]="'incidencia-detalle-page__priority-chip priority-' + getPrioritySlug()"
                  [style.--priority-color]="detallemodal.color">
                  {{ detallemodal.prioridad || "Sin definir" }}
                </strong>
              </div>

              <div class="incidencia-detalle-page__kv-item">
                <span>Tipo</span>
                <strong class="incidencia-detalle-page__type-chip"
                  [class]="'incidencia-detalle-page__type-chip type-' + getTypeSlug()">
                  {{ detallemodal.tipo || "Sin definir" }}
                </strong>
              </div>

              <div class="incidencia-detalle-page__kv-item">
                <span>Versión afectada</span>
                <strong>{{ versionAfectada }}</strong>
              </div>

              <div class="incidencia-detalle-page__kv-item detalle-resolucion__item"
                *ngIf="versionResolucion || resolucionPendiente">
                <span>Versión de resolución</span>
                <div class="detalle-resolucion__valor">
                  <ng-container *ngIf="resolucionPendiente; else versionEntregadaTpl">
                    <b class="detalle-resolucion__chip is-pendiente">
                      <span class="material-icons" aria-hidden="true">schedule</span>{{ nombrePendiente }}
                    </b>
                    <small class="detalle-resolucion__nota">{{ textoSeEntregara }}</small>
                  </ng-container>
                  <ng-template #versionEntregadaTpl>
                    <strong>{{ versionResolucion }}</strong>
                    <b class="detalle-resolucion__chip is-entregada" *ngIf="entregadaEn">
                      <span class="material-icons" aria-hidden="true">inventory_2</span>{{ entregadaEn }}
                    </b>
                  </ng-template>
                </div>
              </div>

              <div class="incidencia-detalle-page__kv-item incidencia-detalle-page__kv-item--owner">
                <span>Asignado actual</span>
                <div class="incidencia-detalle-page__owner-inline">
                  <div class="incidencia-detalle-page__avatar incidencia-detalle-page__avatar--inline">
                    {{ getInitials(nombreCompletoAsignado) }}
                  </div>
                  <strong>{{ nombreCompletoAsignado || "Sin asignar" }}</strong>
                </div>
              </div>
            </div>
          </section>

          <section class="incidencia-detalle-page__card incidencia-detalle-page__card--compact">
            <header class="incidencia-detalle-page__eyebrow-header">
              Registro Temporal
            </header>

            <div class="incidencia-detalle-page__kv-list">
              <div class="incidencia-detalle-page__kv-item">
                <span>Creado por</span>
                <strong>{{ nombreCreadoPor || "N/A" }}</strong>
              </div>

              <div class="incidencia-detalle-page__kv-item">
                <span>Fecha creación</span>
                <strong>{{ detallemodal.fecha_creacion || "N/A" }}</strong>
              </div>

              <div class="incidencia-detalle-page__kv-item">
                <span>Actualización</span>
                <strong>{{ detallemodal.fecha_actualizacion || "N/A" }}</strong>
              </div>
            </div>
          </section>
        </div>

        <section class="incidencia-detalle-page__card">
          <header class="incidencia-detalle-page__section-header">
            <mat-icon>description</mat-icon>
            <h2>Descripción del Problema</h2>
          </header>

          <div class="incidencia-detalle-page__description">
            <p *ngIf="detallemodal.descincidencia; else emptyDescription">
              {{ detallemodal.descincidencia }}
            </p>
            <ng-template #emptyDescription>
              <p class="incidencia-detalle-page__muted">
                No hay descripción registrada para esta incidencia.
              </p>
            </ng-template>
          </div>
        </section>

        <section class="incidencia-detalle-page__card">
          <header class="incidencia-detalle-page__section-header incidencia-detalle-page__section-header--split">
            <div class="incidencia-detalle-page__section-title">
              <mat-icon>attach_file</mat-icon>
              <h2>Evidencias y Adjuntos General</h2>
            </div>

            <span class="incidencia-detalle-page__section-meta">
              {{ listaEvidenciasGeneral.length }} archivo(s)
            </span>
          </header>

          <div class="incidencia-detalle-page__evidence-grid" *ngIf="listaEvidenciasGeneral.length; else emptyEvidence">
            <article class="incidencia-detalle-page__evidence-item"
              *ngFor="let evidencia of listaEvidenciasGeneral; trackBy: trackByEvidencia">
              <div class="incidencia-detalle-page__evidence-icon">
                <mat-icon>{{ iconoEvidencia(evidencia) }}</mat-icon>
              </div>

              <div class="incidencia-detalle-page__evidence-copy">
                <strong>{{ evidencia.nombre }}</strong>
                <span>Adjunto relacionado a la incidencia</span>
              </div>

              <div class="incidencia-detalle-page__evidence-actions">
                <button type="button" mat-icon-button class="btn" title="Ver evidencia"
                  *ngIf="esPrevisualizable(evidencia)"
                  (click)="consultaImagenEvidencia(evidencia)">
                  <mat-icon>visibility</mat-icon>
                </button>

                <button type="button" mat-icon-button class="btn" title="Descargar evidencia"
                  (click)="descargaEvidencia(evidencia)">
                  <mat-icon>download</mat-icon>
                </button>
              </div>
            </article>
          </div>

          <ng-template #emptyEvidence>
            <p class="incidencia-detalle-page__empty">
              No hay evidencias cargadas para esta incidencia.
            </p>
          </ng-template>
        </section>
      </div>

      <aside class="incidencia-detalle-page__sidebar">
        <section class="incidencia-detalle-page__card incidencia-detalle-page__activity-card">
          <header class="incidencia-detalle-page__section-header">
            <mat-icon>forum</mat-icon>
            <h2>Comentarios</h2>
          </header>

          <div class="incidencia-detalle-page__timeline" *ngIf="listadetalles.length; else emptyTimeline">
            <article class="incidencia-detalle-page__timeline-item" *ngFor="let incidencia of listadetalles">
              <div class="incidencia-detalle-page__timeline-dot"></div>

              <div class="incidencia-detalle-page__timeline-content">
                <div class="incidencia-detalle-page__timeline-head">
                  <span class="incidencia-detalle-page__timeline-author">
                    {{ getDetalleAutor(incidencia) }}
                  </span>
                  <span class="incidencia-detalle-page__timeline-date">{{ incidencia.fecha_creacion }}</span>
                </div>

                <ng-container *ngIf="getResolucionEstructurada(incidencia) as resolucion; else legacyDescription">
                  <div class="incidencia-detalle-page__timeline-body incidencia-detalle-page__timeline-body--resolution">
                    {{ resolucion.resolucion }}
                  </div>

                  <section class="incidencia-detalle-page__cause-origin">
                    <button
                      type="button"
                      class="incidencia-detalle-page__cause-origin-toggle"
                      [attr.aria-expanded]="causaOrigenEstaExpandida(incidencia.id)"
                      (click)="alternarCausaOrigen(incidencia.id)"
                    >
                      <span>
                        <mat-icon>account_tree</mat-icon>
                        Causa / Origen
                      </span>
                      <mat-icon>{{ causaOrigenEstaExpandida(incidencia.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>

                    <ol class="incidencia-detalle-page__cause-origin-list"
                      *ngIf="causaOrigenEstaExpandida(incidencia.id)">
                      <li *ngFor="let causa of resolucion.causas">
                        <strong>{{ causa.pregunta }}</strong>
                        <span>{{ causa.respuesta }}</span>
                      </li>
                    </ol>
                  </section>
                </ng-container>

                <ng-template #legacyDescription>
                  <div class="incidencia-detalle-page__timeline-body" *ngIf="tieneTexto(incidencia)">
                    {{ incidencia.descripcion }}
                  </div>
                </ng-template>

                <div class="incidencia-detalle-page__timeline-meta"
                  *ngIf="getDetalleVersion(incidencia) as versionComentario">
                  <span class="incidencia-detalle-page__timeline-version">
                    <mat-icon>sell</mat-icon>
                    Versión:
                    <b class="detalle-resolucion__chip is-pendiente" *ngIf="esVersionPendiente(incidencia); else versionTextoTpl">
                      <span class="material-icons" aria-hidden="true">schedule</span>{{ versionComentario }}
                    </b>
                    <ng-template #versionTextoTpl>{{ versionComentario }}</ng-template>
                  </span>
                </div>

                <div class="incidencia-detalle-page__timeline-files" *ngIf="getDetalleEvidencias(incidencia).length">
                  <span class="incidencia-detalle-page__timeline-file"
                    *ngFor="let evidencia of getDetalleEvidencias(incidencia); trackBy: trackByEvidencia">
                    <button type="button" class="incidencia-detalle-page__timeline-file-open"
                      [title]="esPrevisualizable(evidencia) ? 'Ver evidencia' : 'Descargar evidencia'"
                      (click)="consultaImagenEvidencia(evidencia)">
                      <mat-icon>{{ iconoEvidencia(evidencia) }}</mat-icon>
                      <span>{{ evidencia.nombre }}</span>
                    </button>

                    <button type="button" class="incidencia-detalle-page__timeline-file-download"
                      title="Descargar evidencia" (click)="descargaEvidencia(evidencia)">
                      <mat-icon>download</mat-icon>
                    </button>
                  </span>
                </div>
              </div>
            </article>
          </div>

          <ng-template #emptyTimeline>
            <p class="incidencia-detalle-page__empty">
              No hay actividad registrada para esta incidencia.
            </p>
          </ng-template>

          <div class="incidencia-detalle-page__composer-container" *ngIf="canShowCommentComposer()">
            <form [formGroup]="formComentario" (ngSubmit)="saveInlineComment()" class="w-100">
              <div class="incidencia-detalle-page__composer-header">
                <div class="incidencia-detalle-page__avatar incidencia-detalle-page__avatar--composer">
                  {{ getInitials(nombreUsuarioLogeado || nombreCreadoPor) }}
                </div>
                <div class="incidencia-detalle-page__input-container">
                  <textarea
                    formControlName="descripcion"
                    aria-label="Escribe un comentario"
                    class="incidencia-detalle-page__composer-input"
                    placeholder="Escribe un comentario..."
                    rows="1"
                  ></textarea>
                  <button type="submit" class="incidencia-detalle-page__composer-send-btn"
                    [disabled]="!canSendInlineComment()">
                    <mat-icon>send</mat-icon>
                  </button>
                </div>
              </div>

              <div class="incidencia-detalle-page__composer-footer">
                <label class="incidencia-detalle-page__action-link incidencia-detalle-page__action-link--attach">
                  <mat-icon>attach_file</mat-icon>
                  ADJUNTAR
                  <input type="file" multiple hidden accept="image/*,application/*,audio/*,video/*"
                    (change)="addCommentFiles($event)" />
                </label>

              </div>

              <div class="incidencia-detalle-page__composer-files" *ngIf="evidenciaComentario.length > 0">
                <div *ngFor="let file of evidenciaComentario" class="incidencia-detalle-page__composer-file-chip">
                  <mat-icon class="incidencia-detalle-page__composer-file-icon">attachment</mat-icon>
                  <span class="incidencia-detalle-page__composer-file-name">{{ file.name }}</span>
                  <button
                    type="button"
                    class="incidencia-detalle-page__composer-file-remove"
                    (click)="removeCommentFile(file)"
                    aria-label="Eliminar archivo"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </section>

        <section class="incidencia-detalle-page__card incidencia-detalle-page__card--compact">
          <header class="incidencia-detalle-page__eyebrow-header">
            Acciones
          </header>

          <p class="incidencia-detalle-page__actions-copy">
            Consulta el historial de cambios o reasigna el responsable actual.
          </p>

          <div class="incidencia-detalle-page__owner-actions">
            <button type="button" mat-raised-button class="btn app-form-btn app-form-btn--secondary app-form-btn--compact"
              (click)="verHistorial()">
              Historial de asignaciones
              <span class="incidencia-detalle-page__history-count">
                {{ totalHistorial || 0 }}
              </span>
            </button>

            <button
              type="button"
              mat-raised-button
              class="btn app-form-btn app-form-btn--primary app-form-btn--compact"
              *ngIf="hasAssignmentTools()"
              [disabled]="!canAssignDeveloper()"
              (click)="abrirReasignacion()"
            >
              Reasignar responsable
            </button>
          </div>
        </section>
      </aside>
    </div>
  </div>
</div>
